import { Link } from "react-router-dom";
import { Lightning, ArrowRight, Calculator } from "@phosphor-icons/react";
import PolicyLayout, { Section } from "../../components/public/PolicyLayout";

export default function PriorityRoutes() {
  return (
    <PolicyLayout
      title="Air12 Priority Routes"
      subtitle="Air12 operates on Priority Routes where urgent business cargo can be moved by air subject to shipment clearance, cargo acceptance and flight availability."
      testid="priority-routes-page"
    >
      <div className="grid-card grid-card-strong p-6" data-testid="priority-route-card">
        <div className="flex items-center justify-between">
          <span className="overline">CURRENTLY ACTIVE</span>
          <span className="status-pill status-success">ACTIVE</span>
        </div>
        <div className="flex items-center gap-3 mt-4">
          <span className="id-chip id-chip-strong text-lg px-3 py-1.5">BOM</span>
          <Lightning size={20} weight="fill" className="text-[hsl(var(--accent))]" />
          <span className="id-chip id-chip-strong text-lg px-3 py-1.5">DEL</span>
        </div>
        <p className="text-sm text-[hsl(var(--muted))] mt-4 leading-relaxed">
          Mumbai ↔ Delhi. Air12 attempts movement on the next suitable flight, subject to document clearance,
          cargo acceptance, mandatory insurance, payment confirmation and flight availability.
        </p>
      </div>

      <div className="grid-card grid-card-strong p-6" data-testid="priority-route-card-blr">
        <div className="flex items-center justify-between">
          <span className="overline">CURRENTLY ACTIVE</span>
          <span className="status-pill status-success">ACTIVE</span>
        </div>
        <div className="flex items-center gap-3 mt-4">
          <span className="id-chip id-chip-strong text-lg px-3 py-1.5">BOM</span>
          <Lightning size={20} weight="fill" className="text-[hsl(var(--accent))]" />
          <span className="id-chip id-chip-strong text-lg px-3 py-1.5">BLR</span>
        </div>
        <p className="text-sm text-[hsl(var(--muted))] mt-4 leading-relaxed">
          Mumbai ↔ Bengaluru. Air12 attempts movement on the next suitable flight, subject to document clearance,
          cargo acceptance, mandatory insurance, payment confirmation and flight availability.
        </p>
      </div>

      <Section heading="How Priority Routes work">
        <p>Priority Routes are lanes where Air12 supports urgent business cargo movement by air. Adding a shipment on a
        Priority Route follows the standard Air12 flow: submit shipment details, clear documents, confirm mandatory
        insurance and payment, and Air12 attempts movement on a suitable flight.</p>
      </Section>

      <Section heading="More routes">
        <p>Additional Priority Routes will be announced as they become available. For route requests, contact us at info@air12.in.</p>
      </Section>

      <div className="flex flex-wrap gap-3 pt-2">
        <Link to="/#check-price" className="btn-primary" data-testid="priority-check-price">
          <Calculator size={14} weight="bold" /> Check Price <ArrowRight size={14} weight="bold" />
        </Link>
        <Link to="/track-my-shipment" className="btn-ghost" data-testid="priority-track">
          Track Shipment
        </Link>
      </div>
    </PolicyLayout>
  );
}
